const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const styles = require("./styles/QuantitySelect.css");

module.exports = createReactClass({
	displayName: "QuantitySelectView",

	propTypes: {
		minQty: PT.number,
		minSelectable: PT.number, //The lowest number appearing in the dropdown
		maxSelectable: PT.number, //What number it starts showing option for more+
		maxQty: PT.number,
		initialValue: PT.number,
		disableMore: PT.bool, //don't show option for 10+ and change to input
		disableOptions: PT.bool, //don't show dropdown of options, input only
		showUpdate: PT.bool, //show update button and click to confirm update
		className: PT.string,
		previewClass: PT.string,
		optionClass: PT.string,
		arrowClass: PT.string,
		smallerSize: PT.bool,
		updateQuantity: PT.func,
		tabIndex: PT.number,
	},

	getDefaultProps: function() {
		return {
			minQty: 1,
			minSelectable: 1,
			maxSelectable: 5,
			maxQty: 99,
			previewClass: styles.preview,
			arrowClass: styles.drop,
			optionClass: styles.option,
		};
	},

	getInitialState: function() {
		const quantity = this.props.initialValue || this.props.minQty;
		return {
			isOpen: false,
			isInput: this.props.disableOptions || this.shouldBeInput(quantity),
			quantity,
		};
	},

	componentDidMount() {
		// Ensures that when user touches outside of the input,
		// the dropdown is closed.
		this.isTouchingInput = false;
		document.addEventListener("touchend", this.onTouchEnd);
	},

	componentWillUnmount: function() {
		document.removeEventListener("touchend", this.onTouchEnd);
	},

	shouldBeInput: function(quantity) {
		return !_.inRange(
			quantity,
			this.props.minSelectable,
			this.props.maxSelectable + 1
		);
	},

	UNSAFE_componentWillReceiveProps: function(newProps) {
		if (newProps.initialValue !== this.props.initialValue) {
			this.setState({
				isInput:
					this.props.disableOptions ||
					this.shouldBeInput(newProps.initialValue),
				quantity: newProps.initialValue,
			});
		}
	},

	componentDidUpdate: function(prevProps, prevState) {
		if (this.state.isInput && !prevState.isInput) {
			this.numInput.focus();
		} else if (!this.state.isInput && prevState.isInput) {
			this.dropdown.focus();
		}
	},

	selectOption: function(opt) {
		if (!this.shouldBeInput(opt)) {
			if (this.props.updateQuantity) {
				this.props.updateQuantity(opt);
			}
			this.setState({
				quantity: opt,
				isOpen: false,
				isInput: false,
			});
		} else {
			this.setState({
				quantity: parseInt(this.state.quantity),
				isOpen: false,
				isInput: true,
			});
		}
	},

	onBlurOptions: function() {
		// IE triggers onBlur after option.onMouseDown but before option.onClick
		if (!this.hasRecentlyMousedDown) {
			this.closeOptions();
		}
	},

	mouseDownOnOption: function() {
		// IE triggers onBlur after option.onMouseDown but before option.onClick
		this.hasRecentlyMousedDown = true;
		setTimeout(() => {
			this.hasRecentlyMousedDown = false;
		}, 500);
	},

	updateSelected: function(evt) {
		const code = evt.which;
		const str = String.fromCharCode(code);
		if (code === 38 || code === 40) {
			//up arrow, down arrow
			evt.preventDefault();
			if (this.state.isOpen) {
				const currQty = parseInt(this.state.quantity);
				const newQty = code === 38 ? currQty - 1 : currQty + 1;
				if (
					newQty >= this.props.minSelectable &&
					newQty <= this.props.maxSelectable
				) {
					this.setState({
						quantity: Math.max(
							this.props.minSelectable,
							Math.min(this.props.maxSelectable + 1, newQty)
						),
					});
				} else if (
					newQty === this.props.maxSelectable + 1 &&
					!this.props.disableMore
				) {
					this.setState({quantity: "6+"});
				}
			} else {
				this.setState({isOpen: true});
			}
		} else if (code === 13 || code === 32 || code === 27) {
			//return, space both toggle, esc closes
			evt.preventDefault();
			evt.stopPropagation();
			if (this.state.isOpen) {
				this.closeOptions();
			} else if (code === 13 || code === 32) {
				this.setState({isOpen: true});
			}
		} else if (_.isInteger(parseInt(str))) {
			const num = parseInt(str);
			if (
				_.inRange(num, this.props.minSelectable, this.props.maxSelectable + 1)
			) {
				this.setState({
					quantity: num,
				});
			}
		}
	},

	updateQty: function(evt) {
		const val = evt.target.value;
		const qty = parseInt(val);
		if (val === "" || _.isInteger(qty)) {
			this.setState({
				quantity: !val ? "" : qty,
			});
		}
	},

	checkQty: function(evt, doUpdate) {
		const qty = parseInt(evt.target.value);
		let newQty;
		if (
			(!this.props.showUpdate || !this.state.isInput) &&
			_.isInteger(qty) &&
			this.props.updateQuantity
		) {
			this.props.updateQuantity(qty);
		} else if (!_.isInteger(qty)) {
			newQty = Math.max(this.props.minQty, this.props.initialValue);
			this.props.updateQuantity(newQty);
			this.setState({
				isInput: this.props.disableOptions || this.shouldBeInput(newQty),
				quantity: newQty,
			});
		}
		if (
			this.state.isInput &&
			!this.props.disableOptions &&
			!this.props.showUpdate
		) {
			if (
				_.isInteger(qty) &&
				_.inRange(qty, this.props.minQty, this.props.maxSelectable + 1)
			) {
				this.setState({isInput: false});
			} else if (
				_.isInteger(qty) &&
				(qty < this.props.minQty || qty > this.props.maxQty)
			) {
				newQty = _.clamp(qty, this.props.minQty, this.props.maxQty);
				this.props.updateQuantity(newQty);
				this.setState({
					isInput: this.shouldBeInput(newQty),
					quantity: newQty,
				});
			}
		}
	},

	inputKeyPress: function(evt) {
		if (evt.charCode === 13) {
			if (this.props.showUpdate) {
				this.onClickUpdate();
				this.numInput.blur();
			} else {
				this.checkQty(evt);
			}
		}
	},

	toggleOptions: function() {
		this.setState({isOpen: !this.state.isOpen});
	},

	closeOptions: function(evt) {
		const currQty = parseInt(this.state.quantity);
		if (this.state.isOpen && currQty > this.props.maxSelectable) {
			this.setState({
				isOpen: false,
				isInput: true,
				quantity: currQty,
			});
		} else if (
			_.inRange(currQty, this.props.minSelectable, this.props.maxSelectable + 1)
		) {
			// For dropdown version, only actually update the quantity if it was open.
			// On mobile, onTouchEnd fires for ALL quantity selects on the page when
			// clicking somewhere on the page, so we don't want them to update and cause
			// any vault actions from updateQuantity to be throttled because there are too
			// many coming in a short period of time
			if (
				this.state.isOpen &&
				(!this.props.showUpdate || !this.state.isInput)
			) {
				this.props.updateQuantity(currQty);
			}
			this.setState({
				isOpen: false,
			});
		}
	},

	createOptions: function() {
		const options = _.range(
			this.props.minSelectable,
			this.props.maxSelectable + 1
		);
		if (!this.props.disableMore) {
			options.push(this.props.maxSelectable + 1 + "+");
		}

		return options.map((opt, i) => {
			let className =
				!this.props.disableMore && i === options.length - 1
					? styles.optionMore
					: styles.option;
			if (parseInt(opt) === parseInt(this.state.quantity)) {
				className += " " + styles.selected;
			}

			return (
				<div
					className={className}
					key={"qty" + opt}
					onMouseDown={this.mouseDownOnOption} // for IE
					onClick={() => this.selectOption(opt)}
				>
					<span className={styles.text}>{opt}</span>
				</div>
			);
		});
	},

	onTouchStart: function() {
		this.isTouchingInput = true;
	},

	onTouchEnd: function() {
		if (!this.isTouchingInput) {
			this.closeOptions();
		}
		this.isTouchingInput = false;
	},

	select: function() {
		this.numInput.select();
	},

	renderInput: function() {
		const mainClass =
			styles.inner + (this.props.smallerSize ? " " + styles.smaller : "");
		return (
			<input
				className={mainClass}
				ref={n => (this.numInput = n)}
				onFocus={this.select}
				onKeyPress={this.inputKeyPress}
				onChange={this.updateQty}
				onBlur={this.checkQty}
				value={this.state.quantity}
				maxLength={this.props.maxQty.toString().length}
				tabIndex={this.props.tabIndex}
			/>
		);
	},

	renderOptions: function() {
		let containerStyle = {height: "4rem"};

		let mainClass =
			styles.inner + (this.props.smallerSize ? " " + styles.smaller : "");
		let options = null;
		if (this.state.isOpen) {
			mainClass += " " + styles.mOpen;
			options = <div className={styles.options}>{this.createOptions()}</div>;
			const numSelectables =
				this.props.maxSelectable -
				this.props.minSelectable +
				1 +
				(this.props.disableMore ? 0 : 1);
			containerStyle = {height: numSelectables * 2.5 + "rem"}; //match css .option height
		}

		return (
			<div
				className={mainClass}
				ref={d => (this.dropdown = d)}
				onClick={this.toggleOptions}
				onKeyPress={this.updateSelected}
				onKeyDown={this.updateSelected}
				tabIndex={this.props.tabIndex}
				onBlur={this.onBlurOptions}
				onTouchStart={this.onTouchStart}
			>
				<div className={styles.container} style={containerStyle}>
					{options}
				</div>
				<div className={this.props.previewClass}>{this.state.quantity}</div>
				<div className={this.props.arrowClass}>
					<img
						className={styles.arrow}
						alt="Select"
						src={
							global.BASE_URL +
							"assets/images/office/elements/arrow-right-red.svg"
						}
					/>
				</div>
			</div>
		);
	},

	onClickUpdate: function(evt) {
		this.props.updateQuantity(parseInt(this.state.quantity));
	},

	onKeyPressUpdate: function(evt) {
		if (evt.which === 13) {
			this.onClickUpdate();
		}
	},

	render: function() {
		let element;
		if (this.state.isInput) {
			element = this.renderInput();
		} else {
			element = this.renderOptions();
		}

		let buttonClass = styles.notDisplayed;
		if (this.props.showUpdate) {
			if (
				this.state.quantity !== this.props.initialValue &&
				this.state.isInput &&
				this.state.quantity !== ""
			) {
				buttonClass = styles.update;
			} else {
				buttonClass = styles.hidden;
			}
		}
		const button = (
			<div
				className={buttonClass}
				onClick={this.onClickUpdate}
				tabIndex={this.props.tabIndex + 1}
				onKeyPress={this.onKeyPressUpdate}
			>
				<div className={styles.button}>Update</div>
			</div>
		);
		return (
			<div className={(this.props.className || "") + " " + styles.main}>
				{element}
				{button}
			</div>
		);
	},
});
